import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { links } from "../constants/links";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <a href={links.LINKEDIN} rel="noreferrer" target="_blank">
        <div>
          <BsLinkedin />
        </div>
      </a>
      {/* <a href={github} rel='noreferrer' target='_blank'>
        <div>
          <BsGithub />
        </div>
      </a> */}
    </div>
  );
};

export default SocialMedia;
